var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.itemRent.onlyStock)?_c('div',[_c('i',{staticClass:"icon-only-stock fa-solid fa-grid-2-plus"})]):_vm._e(),(_vm.itemRent.isAccessory)?_c('div',[_c('i',{staticClass:"icon-only-stock fas fa-toolbox"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }